"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _reselect = require('reselect');






const DEFAULT_STATS = {
  not_scheduled: 0,
  queued: 0,
  processing: 0,
  failed: 0,
  completed: 0,
}

 const selectCampaignByKey =
  (state, campaignKey) =>
    state.broadcasts.current[campaignKey] || null; exports.selectCampaignByKey = selectCampaignByKey

 const selectBroadcastMessageByKey =
  (state, patientKey) =>
    state.broadcastMessages.current[patientKey] || null; exports.selectBroadcastMessageByKey = selectBroadcastMessageByKey

 const selectCampaignName =
  _reselect.createSelector.call(void 0, exports.selectCampaignByKey, c => _nullishCoalesce(_optionalChain([c, 'optionalAccess', _ => _.Name]), () => ( null))); exports.selectCampaignName = selectCampaignName

 const selectCampaignOrgKey =
  _reselect.createSelector.call(void 0, exports.selectCampaignByKey, c => _nullishCoalesce(_optionalChain([c, 'optionalAccess', _2 => _2.OrgKey]), () => ( null))); exports.selectCampaignOrgKey = selectCampaignOrgKey

 const selectCampaignTeamKey =
  _reselect.createSelector.call(void 0, exports.selectCampaignByKey, c => _nullishCoalesce(_optionalChain([c, 'optionalAccess', _3 => _3.TeamKey]), () => ( null))); exports.selectCampaignTeamKey = selectCampaignTeamKey

 const selectIsCampaignActive =
  _reselect.createSelector.call(void 0, exports.selectCampaignByKey, c => _nullishCoalesce(_optionalChain([c, 'optionalAccess', _4 => _4.Active]), () => ( false))); exports.selectIsCampaignActive = selectIsCampaignActive

 const selectIsCampaignArchived =
  _reselect.createSelector.call(void 0, exports.selectCampaignByKey, c => _nullishCoalesce(_optionalChain([c, 'optionalAccess', _5 => _5.Archived]), () => ( false))); exports.selectIsCampaignArchived = selectIsCampaignArchived

 const selectCampaignMessageDelay =
  _reselect.createSelector.call(void 0, exports.selectCampaignByKey, c => _optionalChain([c, 'optionalAccess', _6 => _6.MessageDelay]) || null); exports.selectCampaignMessageDelay = selectCampaignMessageDelay

 const selectCampaignStats =
  _reselect.createSelector.call(void 0, exports.selectCampaignByKey, c => _optionalChain([c, 'optionalAccess', _7 => _7.Stats]) || DEFAULT_STATS); exports.selectCampaignStats = selectCampaignStats

 const selectCampaignNotScheduledCount =
  _reselect.createSelector.call(void 0, exports.selectCampaignStats, s => _nullishCoalesce(_optionalChain([s, 'optionalAccess', _8 => _8.not_scheduled]), () => ( 0))); exports.selectCampaignNotScheduledCount = selectCampaignNotScheduledCount

 const selectCampaignHasNotScheduled =
  _reselect.createSelector.call(void 0, exports.selectCampaignNotScheduledCount, n => n > 0); exports.selectCampaignHasNotScheduled = selectCampaignHasNotScheduled

 const selectCampaignQueuedCount =
  _reselect.createSelector.call(void 0, exports.selectCampaignStats, s => _nullishCoalesce(_optionalChain([s, 'optionalAccess', _9 => _9.queued]), () => ( 0))); exports.selectCampaignQueuedCount = selectCampaignQueuedCount

 const selectCampaignHasQueued =
  _reselect.createSelector.call(void 0, exports.selectCampaignQueuedCount, n => n > 0); exports.selectCampaignHasQueued = selectCampaignHasQueued

 const selectCampaignTotalPatientsCount = _reselect.createSelector.call(void 0, 
  exports.selectCampaignStats,
  s => s.not_scheduled + s.queued + s.processing + s.failed + s.completed + (_nullishCoalesce(s.awaiting_consent, () => ( 0))),
); exports.selectCampaignTotalPatientsCount = selectCampaignTotalPatientsCount

 const selectCampaignProgress = _reselect.createSelector.call(void 0, 
  exports.selectCampaignStats,
  exports.selectCampaignTotalPatientsCount,
  (stats, totalCount) => totalCount ? stats.completed / totalCount : 0,
); exports.selectCampaignProgress = selectCampaignProgress

 const selectCampaignHasAnyPatientsToMessage = _reselect.createSelector.call(void 0, 
  exports.selectCampaignStats,
  s => !!(s.not_scheduled || s.queued || s.processing),
); exports.selectCampaignHasAnyPatientsToMessage = selectCampaignHasAnyPatientsToMessage

